import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';

const store = {
  namespaced: true,
  state: {
    records: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {
    recordList: state =>
      state.records.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.status]
      }))
  },
  mutations: {
    setpage(state, page) {
      state.pagination = page;
    },
    setRecords(state, payload) {
      state.records = payload.data;
      state.totalCount = payload.total;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    }
  }
};

appStore.registerModule('foundationRecord', store);
